import { render, staticRenderFns } from "./LineupScreen.vue?vue&type=template&id=87469ee2&scoped=true"
import script from "./LineupScreen.vue?vue&type=script&lang=js"
export * from "./LineupScreen.vue?vue&type=script&lang=js"
import style0 from "./LineupScreen.vue?vue&type=style&index=0&id=87469ee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87469ee2",
  null
  
)

export default component.exports